import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private isSidebarOpen = new BehaviorSubject<boolean>(false); // Default: closed
  sidebarState$ = this.isSidebarOpen.asObservable();


  private isSidebarOpenMobile = new BehaviorSubject<boolean>(false); // Default: closed
  sidebarMobileState$ = this.isSidebarOpenMobile.asObservable();


  toggleSidebar() {
    this.isSidebarOpen.next(!this.isSidebarOpen.value);
  }


  toogleSidebarMobileView() {
    this.isSidebarOpenMobile.next(!this.isSidebarOpenMobile.value);
  }
}